import React, { useState } from "react";
import LineIcon from "lineicons-react";

const Skillcard = ({ icon, iconImage, title, isVerified, desc, styleClass, progress }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        // Introduce a delay of 500ms before setting isHovered to false
        setTimeout(() => {
            setIsHovered(false);
        }, 2500);
    };

    return (
        <div
            className={`relative rounded-lg shadow-md p-6 ${styleClass}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="skill-card">
                <div className="skill-card-body">
                    {iconImage && <img src={iconImage} alt="Icon" className={`skill-card-icon mr-2 inline-block mb-2`} style={{ maxHeight: "24px" }} />}
                    {!iconImage && icon && <i className={`skill-card-icon ${icon} text-xl font-bold mr-2`} style={{ display: "inline" }}></i>}
                    <span className="skill-card-title font-bold text-xl" style={{ display: "inline" }}>{title}</span>
                    {isVerified && (
                        <i className="bi bi-patch-check-fill ml-2 text-white text-xl"></i>
                    )}
                    <p className="skill-card-content mt-1" style={{
                        fontWeight: 350,
                        opacity: isHovered ? 1 : 0,
                        height: isHovered ? "auto" : 0,
                        transition: "opacity 0.3s ease-in-out, height 0.3s ease-in-out",
                        overflow: "hidden",
                        transitionProperty: "height, opacity",
                        transitionDelay: isHovered ? "0s" : "0.5s", // Delay when mouse unhovered
                    }}>{desc}</p>
                </div>
                {progress !== undefined && (
                    <div className="skill-card-progress my-2 py-1 relative">
                        <div className="progress-bar bg-white p-1 rounded-lg opacity-20" style={{ width: `100%`, position: "absolute", zIndex: 1 }}></div>
                        <div className="progress-bar bg-white p-1 rounded-lg opacity-80" style={{ width: `${progress}%`, position: "absolute", zIndex: 2, transition: "width 0.3s ease-in-out" }}></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Skillcard;
